module.exports = __webpack_public_path__ + "img/logoIChart144.f68b20ed.png";